import { render, staticRenderFns } from "./SaveSearchBtn.vue?vue&type=template&id=61948d33&"
import script from "./SaveSearchBtn.vue?vue&type=script&lang=js&"
export * from "./SaveSearchBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports